import { useCallback, useState } from 'react';

import { AxiosError } from 'axios';

import { getBackendErrorMessage } from '@/shared/lib/errors';
import { useSnackbar } from '@/shared/lib/hooks/useAppSnackbar';

import { useShippingService } from './shipping.service';

export interface ShipmentLabelOpener {
  openLabel: (shipmentId: string) => Promise<void>;
  openingShipmentId: string | null;
}

export const useShipmentLabel = (): ShipmentLabelOpener => {
  const { getShipmentLabel } = useShippingService();
  const { enqueueSnackbar } = useSnackbar();
  const [openingShipmentId, setOpeningShipmentId] = useState<string | null>(null);

  const openLabel = useCallback(
    async (shipmentId: string) => {
      if (openingShipmentId) return;

      const pdfTab = window.open('', '_blank');
      setOpeningShipmentId(shipmentId);
      try {
        const blob = await getShipmentLabel(shipmentId);
        const url = URL.createObjectURL(blob);
        if (pdfTab) pdfTab.location.href = url;
        else window.open(url, '_blank');
      } catch (error) {
        pdfTab?.close();
        enqueueSnackbar(getBackendErrorMessage(error as AxiosError), { variant: 'error' });
      } finally {
        setOpeningShipmentId(null);
      }
    },
    [enqueueSnackbar, getShipmentLabel, openingShipmentId],
  );

  return { openLabel, openingShipmentId };
};
